import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=0c65e1d9&scoped=true&"
import script from "./Three.vue?vue&type=script&lang=js&"
export * from "./Three.vue?vue&type=script&lang=js&"
import style0 from "./Three.vue?vue&type=style&index=0&id=0c65e1d9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65e1d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VContainer,VRadio,VRadioGroup})
